module.exports = __webpack_public_path__ + "img/chi.1a12c681.png";